import { render } from "./AppModal.vue?vue&type=template&id=ab1c27bc"
import script from "./AppModal.vue?vue&type=script&lang=ts"
export * from "./AppModal.vue?vue&type=script&lang=ts"

import "./AppModal.vue?vue&type=style&index=0&id=ab1c27bc&lang=scss"
script.render = render

export default script